import { useCallback } from 'react';
import { useNotification } from '@/hooks';
import { NotificationSeverity } from '@/components/notifications/Notification';
import { useDeleteServiceVisitTypeMutation } from '../services';

const useDeleteServiceVisitType = () => {
  const { showNotification } = useNotification();

  const [deleteServiceVisitType, { isLoading: isDeleting }] =
    useDeleteServiceVisitTypeMutation();

  const handleDelete = useCallback(
    async (id: string, name: string): Promise<void> => {
      if (
        !window.confirm(
          `¿Está seguro de que desea eliminar el tipo de visita "${name}"?`
        )
      ) {
        return;
      }

      try {
        await deleteServiceVisitType(id).unwrap();
        showNotification(
          'Tipo de visita eliminado correctamente',
          NotificationSeverity.success
        );
      } catch (error: any) {
        const message =
          error?.data?.message ??
          error?.message ??
          'Error al eliminar el tipo de visita';
        showNotification(message, NotificationSeverity.error);
      }
    },
    [deleteServiceVisitType, showNotification]
  );

  return { handleDelete, isDeleting };
};

export default useDeleteServiceVisitType;
